import { Field, Form as FormikForm, Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import {
  Accordion,
  Button,
  Card,
  Col,
  Form,
  Row,
  Spinner,
} from 'react-bootstrap';
import * as Yup from 'yup';
import { getDocumentType, toBase64 } from 'utils';
import { toast } from 'react-toastify';

import infoIco from '../../../assets/images/i-circle.svg';
import Verified from '../../../assets/images/verified.gif';
import buySellService from 'services/buy-sell.service';
import DashboardHttp from '../services/profile.service';
import { userStore } from 'store/UserStore';
import { TRADEMARK_LOGO_URL } from 'constants/messages.constant';
import Loader from 'shared/common/loader';

const SUPPORTED_FORMATS = [
  // 'image/jpg',
  // 'image/jpeg',
  // 'image/png',
  'application/pdf',
  // 'application/msword',
];
const FILE_SIZE = 5 * 1024 * 1024;

const Documents = ({ user }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [base64File, setBase64File] = useState('');
  const [loading, setLoading] = useState(false);
  const [esignLoading, setEsignLoading] = useState(false);
  const [fileUrl, setFileUrl] = useState('');

  const [customerId, customer, userData, selectedAccount, setCustomer] =
    userStore((state: any) => [
      state.customerId,
      state.customer,
      state.userData,
      state.selectedAccount,
      state.setCustomer,
    ]);

  useEffect(() => {
    if (
      customer.companyData?.eSign &&
      customer.companyData.eSign.documentStatus === 'Completed'
    ) {
      getSignedDocument(customer.companyId);
    }
  }, [customer]);

  const fileChanged = async (event: any) => {
    setSelectedFile(event.currentTarget.files[0]);
    let file: any = await toBase64(event.currentTarget.files[0]);
    setBase64File(file);
  };

  const esignCallback = (response) => {
    setEsignLoading(false);
    if ('message' in response) {
      toast.success('Document e-signed and uploaded successfully');
      getProfile(customerId);
    }
    if ('error' in response) {
      toast.error('E-sign failed');
    }
  };

  const trimBase64 = (file) => {
    return file.split(',')[1];
  };

  const uploadDocument = async () => {
    if (base64File) {
      try {
        let payload = {
          companyId: customer.companyId,
          file: trimBase64(base64File),
          name: customer?.user?.firstName,
          documentName: selectedFile.name,
          email: userData.email,
          mobile: userData.phone_number,
        };
        setLoading(true);
        const res: any = await buySellService.uploadDocument(payload,user?.userId);

        if (res.status == 200 && res.data) {
          let win: any = window;

          const obj = {
            logoUrl: TRADEMARK_LOGO_URL,
            callback: esignCallback,
          };
          const leegality = new win.Leegality(obj);
          leegality.init();
          leegality.esign(res.data.data.result.signUrl);
          setEsignLoading(true);
        }
      } catch (error) {
        toast.error('Error in uploading the file');
      } finally {
        setLoading(false);
      }
    } else {
      toast.error('File not selected');
    }
  };

  const getProfile = async (customerId: any) => {
    try {
      setLoading(true);
      const userData: any = await DashboardHttp.getProfile(customerId,user?.userId);
      if (userData.status === 200 && userData.data.data) {
        setCustomer(userData.data.data.customer);
      }
    } catch (e: any) {
      console.log(e);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const getSignedDocument = async (companyId: any) => {
    try {
      setLoading(true);
      const response: any = await buySellService.getSignedDocument(companyId,user?.userId);
      if (response.status === 200 && response.data) {
        setFileUrl(response.data.data);
      }
    } catch (e: any) {
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card>
      {esignLoading && <Loader />}
      <Card.Body className='p-md-5 p-sm-2 pb-0'>
        <Card.Title className='mb-5'>Documents</Card.Title>

        {customer.companyData?.eSign &&
        customer.companyData.eSign.documentStatus === 'Completed' ? (
          <Row className='my-2'>
            <Col md={6}>{getDocumentType(customer.customerType).type}</Col>
            <Col md={6} className='text-right d-flex align-items-center'>
              <a href={fileUrl} className='mx-2' target='_blank'>
                <b>View Signed Document</b>
              </a>
              <img src={Verified} width='18px' height='18px' />
              <br />
            </Col>
          </Row>
        ) : (
          <div>
            <Formik
              initialValues={{ brFile: '' }}
              validationSchema={Yup.object().shape({
                brFile: Yup.mixed()
                  .nullable()
                  .required('Document is required')
                  .test('fileSize', 'File is bigger than 1MB', (value) => {
                    return value && value?.size <= FILE_SIZE;
                  })
                  .test(
                    'fileType',
                    'Unsupported file format. Please upload file in PDF format',
                    (value) => value && SUPPORTED_FORMATS.includes(value?.type)
                  ),
              })}
              onSubmit={(values, { setFieldError, setFieldTouched }) => {
                uploadDocument();
              }}
            >
              {({ errors, touched, setFieldValue }) => (
                <FormikForm>
                  <Form.Group className='mb-3 ' controlId='entForm.comp-spoc'>
                    <Form.Label>
                      {getDocumentType(customer.customerType).type}
                    </Form.Label>

                    <small className='text-muted mx-2'>
                      {`(${
                        getDocumentType(customer.customerType).description
                      })`}
                    </small>
                    <Field
                      type='file'
                      placeholder=''
                      name='brFile'
                      className='form-control mt-2'
                      // value={values.brFile}
                      value={undefined}
                      onChange={(e) => {
                        fileChanged(e);
                        setFieldValue('brFile', e.currentTarget.files[0]);
                      }}
                    />
                    <div className='error'>
                      {errors.brFile && touched.brFile && (
                        <small id='my-helper-text'>
                          <img src={infoIco} alt='' />
                          {errors.brFile}
                        </small>
                      )}
                    </div>
                  </Form.Group>
                  <Form.Group>
                    <Button
                      className='w-100 mt-3'
                      variant='primary'
                      type='submit'
                      disabled={loading}
                    >
                      Upload
                      {loading ? (
                        <Spinner animation='border' size='sm'></Spinner>
                      ) : null}
                    </Button>
                  </Form.Group>
                </FormikForm>
              )}
            </Formik>
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default Documents;
